import styled from 'styled-components'
import { devices } from '../../../../globalStyle'
import arrowDown from '../../../../assets/certificates/AddCertificate/arrow-down.svg'
import calendar from '../../../../assets/calendar-icon.svg'
import search from '../../../../assets/router/search.svg'
import checked from '../../../../assets/router/checked.svg'
import cross from '../../../../assets/addStockModal/pages/cross.svg'
import check from '../../../../assets/addStockModal/pages/check.svg'

export const Container = styled.div`
    display: flex;
    border-radius: 5px;
    margin-left: 0.5rem;
    margin-top: 0.5rem;
    width: 97%;
    height: 100%;
`
export const BigText = styled.h1`
    margin-left: 0.5rem;
    font-size: clamp(1.4rem, calc(1.4rem + 0.15vw), 2.8rem);
    font-family: 'Inter', sans-serif;
`
export const DivComponents = styled.div`
  /* border: solid #000; */
  width: 100%;
  height:97%;
 
`

export const ContainerHeader = styled.div`
  display: flex;
  background-color: #fff;
  width: 97%;
  height: 10vh;
  margin-top: 2.2vh;
  margin-left: 0.5rem;
  border-radius: 5px;
  
  justify-content: space-between;
  align-items: center;

  @media ${devices.largeDesktop} {
    
  }
`
export const FormContainer = styled.div`
    width: 30%;
    height: 95%;
    background-color: #fff;
    padding: 0.5rem;
    /* border:  solid red; */
    border-radius: 5px;
    margin-right: 1rem;
`

export const IframeContainer = styled.div`
    width: 100%;
    height: 100%;
    background-color: #fff;
    /* border:  solid blue; */
    padding: 0.5rem;
    border-radius: 5px;

    @media (max-width: 1920px) {
      height: 100%;
    }
`

export const MapWrapper = styled.div`
    width: 100%;
    height: 100%;
    min-height: 28rem; /* minHeight padrão para telas maiores */
    @media (max-width: 1920px) {
        min-height: 20rem; /* minHeight para telas menores ou iguais a 1920px */
    }
    

    /* Opcional: Se você quiser que o mapa não ultrapasse uma largura máxima em telas muito grandes */
    max-width: 1600px;
    margin: 0 auto;
`;
export const InputDiv = styled.div`
    margin-left: 0.92rem;
    margin-top: 1.2rem;
    position: relative;

    .empty {
        border: 0;
    }

    .isDisabled {
       cursor: not-allowed;
    }
`

export const InputLabel = styled.label`
    display: block;
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: clamp(0.7rem, calc(0.7rem + 0.1vw) , 1.5rem);
`

export const Input = styled.input`
    width: 9.5vw;
    height: 5.3vh;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 2vw;
    margin-top: 0.8vh;
    margin-right: 1vh;
    padding-left: 1vw;
    padding-right: 1vw;
    font-size: 1vw;
    width: 100%;
    color: #696969;
    :focus {
        outline: 0;
    }
        ::placeholder {
    color: #999;
    font-style: italic;
  }
`

export const StyledSelect = styled.select`
    background-color: #ebebeb;
    color: #777777;
    height: 2.2rem;
    width: 50%;
     font-size: clamp(0.6rem, calc(0.6rem + 0.1vw) , 1.3rem);
    margin-top: 0.45rem;
    padding-left: 0.92rem;
    padding-right: 2.15rem;
    border-radius: 1.78rem;
    border: 1px solid #e1e1e1;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url(${arrowDown});
    background-repeat: no-repeat;
    background-position-x: 10.1rem;
    background-position-y: 0.7rem;
    background-size: 1.2rem;

    :focus{
        outline: 0;
    }

    @media (max-width: 1920px) {
        width: 12.2rem;
    }
    @media (min-width: 1920px) {
        width: 12.2rem;
    }
    @media (max-width: 960px) {
        width: 9.8rem;
    }

    @media (max-width: 720px) {
        width: 7.2rem;
    }

    @media (max-width: 480px) {
        width: 6rem;
    }

    &.client{
        width: 25vw;
        background-position-x: 19rem;
        background-position-y: 0.7rem;
        background-size: 1.2rem;
    }
`


export const ButtonOfSection = styled.div`
  display: flex;
  align-items: center;
  width: auto;
  height: 2.2vw;
  background-color: #0090d3;
  border-radius: 1vw;
  justify-content: space-around;
  cursor: pointer;
  padding:.7vw;
  margin-right: 3vw;
  @media ${devices.largeDesktop} {
    width: 7rem;
  }

  &.reverse{
    background-color: #fff;
    border: 1px solid #0090d3;
  }
`
export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const OptionsDiv = styled.div `
    display: flex;
    justify-content: flex-end;
    margin-top: 1vw;
    margin-bottom: 1vw;

    &.reverse{
      justify-content: flex-start;
      margin-top: 0;
      margin-bottom: 0;
      
      padding-left: 0.5rem;
    }
`
export const ButtonContainer = styled.div`
  width: 100%;
  height: 2.5rem;
  display: flex;
  justify-content: flex-end;
  padding-right: 1rem;
  
`
export const ButtonOfSectionText = styled.p`
  color: #fff;
  font-weight: 600;
  font-size: 0.9vw;
  
  font-family: 'Inter', sans-serif;
  font-weight:700;

  @media ${devices.largeDesktop} {
    font-size: 0.6vw;
  }

  &.reverse{
    color: #0090d3;
  }
`

export const StyledDate = styled.input`
  background-color: #ebebeb;
  color: #777777;
  height: 2.2rem;
  width: 13rem;
  font-size: 1rem;
  margin-top: 0.45rem;
  padding-left: 0.92rem;
  padding-right: 2.15rem;
  border-radius: 1.78rem;
  border: 1px solid #e1e1e1;
  -webkit-appearance: none;
  -moz-appearance: none;

  background-image: url(${calendar});
  background-repeat: no-repeat;
  background-position-x: 9.1rem;
  background-position-y: -0.5rem;
  background-size: 3rem;

  :focus {
    outline: 0;
  }

  ::placeholder {
    color: #999;
  }

  

  @media (max-width: 1920px) {
    width: 12.2rem;
  }

  @media (max-width: 960px) {
    width: 9.8rem;
  }

  @media (max-width: 720px) {
    width: 7.2rem;
  }

  @media (max-width: 480px) {
    width: 6rem;
  }
`;


export const StyledSearch = styled.input`
  background-color: #ebebeb;
  color: #777777;
  height: 2.2rem;
  width: 13rem;
  font-size: 1rem;
  margin-top: 0.45rem;
  padding-left: 0.92rem;
  padding-right: 2.15rem;
  border-radius: 1.78rem;
  border: 1px solid #e1e1e1;
  -webkit-appearance: none;
  -moz-appearance: none;

  background-image: url(${search});
  background-repeat: no-repeat;
  background-position-x: 9.9rem;
  background-position-y: 0.3rem;
  background-size: 1.5rem;

  :focus {
    outline: 0;
  }

  ::placeholder {
    color: #999;
  }

  

  @media (max-width: 1920px) {
    width: 12.2rem;
  }

  @media (max-width: 960px) {
    width: 9.8rem;
  }

  @media (max-width: 720px) {
    width: 7.2rem;
  }

  @media (max-width: 480px) {
    width: 6rem;
  }
`;

export const StyledOption = styled.option`
    background-color: #fff;
    height: 0.7rem;
    font-size: clamp(0.5rem, calc(0.6rem + 0.1vw) , 1.3rem);
`

export const StyledLink = styled.p`
  color: #696969;
  font-size: 0.8rem;


  &.linkMode{
    color: #0090D3;
    cursor: pointer;
  }
`

export const OptionsContainer = styled.div`
  width: 90%;
  border-radius: 0.3rem;
  height: 30%;
  background-color: #e1e1e1;
  padding: 0.5rem;
  margin-top: 1rem;
  overflow: auto;
  /* border: solid green; */

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ffffff; /* Cor do thumb do scrollbar */
    border-radius: 3px; /* Border radius do thumb */
  }

  &::-webkit-scrollbar-track {
    background: #c0c0c0; /* Cor de fundo do scrollbar */
    border-radius: 3px; /* Border radius do track */
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555555; /* Cor do thumb ao passar o mouse por cima */
  }

  @media (min-width: 2000px) {
    height: 50%;
  }
`

export const SelectData = styled.select`
  width: 100%;
  border: none;
  outline: none;
  background-color: #EBEBEB;
  height: 2.4rem;
  max-height: 50px;
  overflow-y: auto;
  padding: 0 1rem;
  border-radius: 2rem;
`

export const StyledCheckList = styled.div `
  width: 1.2rem;
  height: 1.2rem;
  
  background-color: #fff;
  border:  solid 1px #C4C4C4;
  border-radius: 0.2rem;
  color: #fff;
 

  &.selected{
    background-image: url(${checked});
    background-color: #0090D3;
    border:  solid 1px #0090D3;
    background-size: 1rem;
    background-repeat: no-repeat;
  }
  
`
export const StyledChecklistContainer = styled.div`
  display:  flex;
  width:20%;
  justify-content: center;
  /* border: solid black; */
`

export const StyledFreight = styled.div `
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  border-radius: 0.3rem;
  height: 3rem;
  background-color: #fff;
  margin-top: 0.5rem;
  padding-left: 0.2rem;
  cursor: pointer;
`

export const FreightInfo = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
`

export const StyledFreightText = styled.div `
  font-weight: bolder;
  font-size: small;
`
export const StyledFreightSubText = styled.div `
  font-size: x-small;
  color: #696969;
  margin-top: 0.2rem;
`

export const SwitchDiv = styled.div`
    display: flex;
    flex-direction: column;
`

export const SwitchBox = styled.label`
    display: inline-block;
    position: relative;
    width: 60px;
    height: 34px;
`

export const SwitchInput = styled.input`
    opacity: 0;
    width: 0;
    height: 0;

    :checked + .slider {
        background-color: #2196F3;
        border: 0;
        padding: 2px;
    }

    :focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    :checked + .slider:before {
        background-image: url(${check});
        background-repeat: no-repeat;
        background-position: center;
        background-size: 15px 15px;
        background-color: #fff;
        -webkit-transform: translateX(24px);
        -ms-transform: translateX(24px);
        transform: translateX(24px);
    }
`

export const SwitchSlider = styled.span`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 34px;
    border: #696969 2px solid;

    :before {
        display: block;
        position: relative;
        content: "";
        height: 24px;
        width: 24px;
        left: 5.5px;
        top: 2.8px;
        background-color: #696969;
        border-radius: 50%;
        transition: all 0.4s;
        background-image: url(${cross});
        background-repeat: no-repeat;
        background-position: center;
        background-size: 11px 11px;
    }
`